import { render, staticRenderFns } from "./snowprinces.vue?vue&type=template&id=d47126e6"
import script from "./snowprinces.vue?vue&type=script&lang=js"
export * from "./snowprinces.vue?vue&type=script&lang=js"
import style0 from "./snowprinces.vue?vue&type=style&index=0&id=d47126e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports